import styled from 'styled-components';

import { colors } from 'styles/theme/colors';
import { FONT_WEIGHT_MEDIUM } from 'styles/theme/textStyles';

type Props = {
  count: number;
  className?: string;
};

// The unread count pill (Figma "Multi Facility Access"): a light-red pill with a dark-red count,
// shared by the per-facility rail rows and the summed Chat tab affix. Renders nothing at 0 so
// callers can drop it in unconditionally. A dedicated atom rather than the shared `Badge`
// (which is a wide label pill: lighter red10 fill, 12px side padding) — a count badge is
// compact and higher-contrast, and both badge sites must match it exactly.
export default function UnreadBadge({ count, className }: Props) {
  if (count <= 0) return null;

  return (
    <Pill className={className} data-testid='chat-unread-badge' aria-label={`${count} unread`}>
      {count}
    </Pill>
  );
}

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 10px;
  background: ${colors.red25};
  color: ${colors.redHover};
  font-size: 12px;
  /* Medium, not bold — per design review of the Figma comp. */
  font-weight: ${FONT_WEIGHT_MEDIUM};
  line-height: 1;
`;
